import { useState } from 'react';
import { BASEJUMP_BI_CONTRACT_ADDRESS } from '../constants';

const IS_PRODUCTION = (process.env.REACT_APP_IS_PRODUCTION || 'false').toLowerCase() === 'true'

const getInventoryExploreUrl = () => {
  return IS_PRODUCTION
    ? `https://opensea.io/assets/base/${BASEJUMP_BI_CONTRACT_ADDRESS}`
    : `https://testnets.opensea.io/assets/base-sepolia/${BASEJUMP_BI_CONTRACT_ADDRESS}`;
}

export default function useInventory(items) {
  const equippedItems = items.filter((i) => i.isEquipped());

  const slotConfig = [
    'object',
    'armor',
    // 'clothing',
    'weapon'
  ];

  const slots = slotConfig.map((c) => {
    return {
      exploreUrl: getInventoryExploreUrl(),
      type: c,
      image: `/assets/inv_${c}.svg`,
      logo: `/assets/inv_logo_${c}.svg`,
      equipped: equippedItems.find((i) => i.getType() === c),
      options: items.filter((i) => i.getType() === c)
    }
  });

  return { slots };
}
